import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const MilkInspectorsReportConfig = {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/milk-inspectors-report', component: FuseLoadable({ loader: () => import('./ViewMilkInspectorsReportApp') }) }],
};

export default MilkInspectorsReportConfig;
